module.exports = __webpack_public_path__ + "img/PerformDash-Advance-Header.4a9a9148.svg";